import React from "react";
 import { InputMediu } from "./styles";
const Input = ({ type, className, register, onChange, name, defaultValue, value, placeholder, mandatory, title, disabled, style, width , erro }) => {
  
  
    return(
    <InputMediu 
    type={type}
    className={className}
    name={name} 
    {...register} 
    value={value} 
    style={style} 
    onWheel={() => document.activeElement.blur()}
    placeholder={placeholder} 
    disabled={disabled} 
    onChange={onChange} />
        )
}
export default Input;